// Бічна навігація для ДЕСКТОПНОЇ веб-версії (поза Telegram).
// Показується лише на широких екранах (lg+) і лише у веб-режимі — замість
// нижнього TabBar, щоб сайт виглядав як повноцінний веб-застосунок, а не
// вузька мобільна колонка. У Telegram Mini App не використовується.
import { NavLink, Link } from 'react-router-dom';
import { useFetch } from '../lib/useFetch';
import { api } from '../lib/api';
import { haptic } from '../lib/telegram';

const items = [
  { to: '/', label: 'Головна', icon: '🏠' },
  { to: '/categories', label: 'Тести', icon: '📚' },
  { to: '/signs', label: 'Дорожні знаки', icon: '🚦' },
  { to: '/battles', label: 'Битви', icon: '⚔️' },
  { to: '/leaderboard', label: 'Лідерборд', icon: '🏆' },
  { to: '/premium', label: 'Premium', icon: '👑' },
  { to: '/profile', label: 'Профіль', icon: '👤' },
] as const;

export function Sidebar() {
  const { data } = useFetch(() => api.me(), []);
  const photoUrl = data?.user.photoUrl ?? null;
  const isPremium = data?.user.isPremium ?? false;
  const name = data?.user.firstName ?? 'Профіль';
  const level = data?.user.level ?? 1;

  return (
    <aside className="sticky top-0 hidden h-screen w-60 shrink-0 flex-col border-r border-tg-secondary-bg bg-tg-bg/70 px-3 py-5 backdrop-blur lg:flex">
      <Link to="/" className="mb-6 flex items-center gap-2.5 px-2">
        <span className="grid h-9 w-9 place-items-center rounded-xl bg-tg-success text-lg">🚦</span>
        <span className="text-base font-semibold">Тести ПДР</span>
      </Link>

      <nav className="flex flex-1 flex-col gap-1">
        {items.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            end={t.to === '/'}
            onClick={() => haptic.selection()}
            className={({ isActive }) =>
              `flex items-center gap-3 rounded-xl px-3 py-2.5 text-sm font-medium transition ${
                isActive
                  ? 'bg-tg-button text-tg-button-text'
                  : 'text-tg-hint hover:bg-tg-secondary-bg hover:text-tg-text'
              }`
            }
          >
            <span className="text-lg leading-none">{t.icon}</span>
            {t.label}
          </NavLink>
        ))}
      </nav>

      <Link
        to="/profile"
        className="mt-2 flex items-center gap-3 border-t border-tg-secondary-bg px-2 pt-4"
      >
        {photoUrl ? (
          <img
            src={photoUrl}
            alt=""
            className={`h-9 w-9 rounded-full object-cover ${isPremium ? 'ring-2 ring-yellow-500' : ''}`}
          />
        ) : (
          <span className="grid h-9 w-9 place-items-center rounded-full bg-tg-secondary-bg text-base">
            👤
          </span>
        )}
        <div className="min-w-0">
          <div className="truncate text-sm font-medium">{name}</div>
          <div className="text-xs text-tg-hint">
            {isPremium ? '👑 Premium' : `Рівень ${level}`}
          </div>
        </div>
      </Link>
    </aside>
  );
}
